import { TextField } from '@mui/material'
import { GRID_FORM_CONFIG_T } from '../../../../common/FormGenerator'
import { AutocompleteInput } from '../../../../components/ui-kit/AutocompleteInput'
import { AvatarUpload } from '../../../../components/ui-kit/AvatarUpload'
import { russiaRegionsOptions } from '../../../../consts/russiaRegions'
import type { TeamFormValues } from '../ZodValidationSchema'

export type DraftTeamBlockName =
  | 'title'
  | 'city'
  | 'status'
  | 'descriptionShort'
  | 'region'
  | 'image'
  | 'goalsText'
  | 'resourcesText'
  | 'needsText'

const titleConfig: GRID_FORM_CONFIG_T<TeamFormValues> = [
  [
    {
      id: 1,
      controllerName: 'title',
      RenderElement: TextField,
      renderProps: () => ({
        placeholder: 'Название команды',
        fullWidth: true,
        size: 'small',
        inputProps: { maxLength: 240 },
      }),
    },
  ],
]

const cityConfig: GRID_FORM_CONFIG_T<TeamFormValues> = [
  [
    {
      id: 2,
      controllerName: 'city',
      RenderElement: TextField,
      renderProps: () => ({
        placeholder: 'Населённый пункт',
        fullWidth: true,
        size: 'small',
      }),
    },
  ],
]

const statusConfig: GRID_FORM_CONFIG_T<TeamFormValues> = [
  [
    {
      id: 3,
      controllerName: 'status',
      RenderElement: TextField,
      renderProps: () => ({
        placeholder: 'Статус / слоган',
        fullWidth: true,
        size: 'small',
      }),
    },
  ],
]

const descriptionShortConfig: GRID_FORM_CONFIG_T<TeamFormValues> = [
  [
    {
      id: 4,
      controllerName: 'descriptionShort',
      RenderElement: TextField,
      renderProps: () => ({
        placeholder: 'Краткое описание',
        fullWidth: true,
        multiline: true,
        minRows: 2,
        size: 'small',
        inputProps: { maxLength: 500 },
      }),
    },
  ],
]

const regionConfig: GRID_FORM_CONFIG_T<TeamFormValues> = [
  [
    {
      id: 6,
      controllerName: 'region',
      RenderElement: AutocompleteInput,
      renderProps: () => ({
        options: russiaRegionsOptions,
        freeSolo: false,
        fullWidth: true,
        size: 'small',
        placeholder: 'Выберите регион',
      }),
    },
  ],
]

const imageConfig: GRID_FORM_CONFIG_T<TeamFormValues> = [
  [
    {
      id: 7,
      controllerName: 'image',
      RenderElement: AvatarUpload,
      renderProps: () => ({
        hideRemove: true,
      }),
    },
  ],
]

const multilineConfig = (
  id: number,
  controllerName: 'goalsText' | 'resourcesText' | 'needsText',
  placeholder: string,
  minRows?: number
): GRID_FORM_CONFIG_T<TeamFormValues> => [
  [
    {
      id,
      controllerName,
      RenderElement: TextField,
      renderProps: () => ({
        placeholder,
        fullWidth: true,
        multiline: true,
        ...(minRows != null && { minRows }),
        size: 'small',
      }),
    },
  ],
]

const goalsConfig = multilineConfig(9, 'goalsText', 'Цели')
const resourcesConfig = multilineConfig(10, 'resourcesText', 'Ресурсы', 2)
const needsConfig = multilineConfig(11, 'needsText', 'Потребности', 2)

const formConfigs: Record<DraftTeamBlockName, GRID_FORM_CONFIG_T<unknown>> = {
  title: titleConfig as GRID_FORM_CONFIG_T<unknown>,
  city: cityConfig as GRID_FORM_CONFIG_T<unknown>,
  status: statusConfig as GRID_FORM_CONFIG_T<unknown>,
  descriptionShort: descriptionShortConfig as GRID_FORM_CONFIG_T<unknown>,
  region: regionConfig as GRID_FORM_CONFIG_T<unknown>,
  image: imageConfig as GRID_FORM_CONFIG_T<unknown>,
  goalsText: goalsConfig as GRID_FORM_CONFIG_T<unknown>,
  resourcesText: resourcesConfig as GRID_FORM_CONFIG_T<unknown>,
  needsText: needsConfig as GRID_FORM_CONFIG_T<unknown>,
}

export const getFormConfig = (blockName: DraftTeamBlockName) => formConfigs[blockName]
